module.exports = __webpack_public_path__ + "static/media/step1.2b29e966.png";